angular.module('rjmNg.directives').controller 'columnListCtrl', [
  "$scope"
  "$rootScope"
  "$window"
  "jobService"
  "notification"
  "errorConstants"
  "app"
  "$modal"
  "Columns"
  "remoteDBConnectionService"
  "logger"
  "rjdl"
  "columnService"
  "StructureCache"
  "dataWarehouse"
  "Tables"
  "$anchorScroll"
  "$timeout"
  "$location"
  "ImplementationTags"
  "$q"
  (
    $scope
    $rootScope
    $window
    jobService
    notification
    errorConstants
    app
    $modal
    Columns
    remoteDBConnectionService
    logger
    rjdl
    columnService
    StructureCache
    dataWarehouse
    Tables
    $anchorScroll
    $timeout
    $location
    ImplementationTags
    $q
  ) ->
    IS_SUPPORT_USER = app.isSupportUserSession()

    ADDITION_TO_NOTIFICATION = if app.hasFeatureFlag('PERSISTENT_VIEWS') then "and Data Warehouse Views " else ""

    $scope.pkTooltipText = "Primary keys can't be removed without dropping the entire table."
    $scope.loadingTags = false
    $scope.implementationTags = null
    getAllImplementationTags = ->
      deferred = $q.defer()
      if $scope.implementationTags?
        deferred.resolve $scope.implementationTags
      else
        ImplementationTags.getTagTypes().then (tags) ->
          $scope.implementationTags = tags
          deferred.resolve tags
        , (error) ->
          $scope.implementationTags = null
          deferred.reject error
      deferred.promise

    $scope.getTagsForColumn = (column) ->
      $scope.loadingTags = true
      $q.all([getAllImplementationTags(),
              ImplementationTags.getTagsForColumn(column)])
      .then ([tags, columnTags]) ->
        $scope.loadingTags = false
        _.map(tags, (tag) ->
          if(_.contains(columnTags, tag.id))
            tag.checked = true
          else
            tag.checked = false
        )
      , (error) ->
        $scope.loadingTags = false
        $scope.implementationTags = null # clear ALL known tags
        notification.error("Server Error", error, "data-warehouse-notifications", '', 5)

    $scope.checkOrUncheckTag = ({id: sid}, tag) ->
      if tag.checked
        ImplementationTags.removeTag(sid, tag.id).then () ->
          tag.checked = false
          notification.success('Removed Tag', 'Removed Tag', "data-warehouse-notifications", '', 5)
        , (error) ->
          $scope.implementationTags = null # clear ALL known tags
          notification.error("Server Error", error, "data-warehouse-notifications", '', 5)
      else
        ImplementationTags.addTag(sid, tag.id).then () ->
          tag.checked = true
          notification.success('Added Tag', 'Added Tag', "data-warehouse-notifications", '', 5)
        , (error) ->
          $scope.implementationTags = null # clear ALL known tags
          notification.error("Server Error", error, "data-warehouse-notifications", '', 5)

    $scope.showTagMenu = (column) ->
      column.isView and IS_SUPPORT_USER

    $scope.fieldTypes = _.values(dataWarehouse.FIELD_TYPES)

    $scope.fieldTypeNameMap = $scope.fieldTypes.reduce (acc, value) ->
      acc[value.id] = value.name
      acc
    , {}

    $scope.recheckOptions = (value for key, value of dataWarehouse.RECHECK_TYPE)
    pkAlert = "This table needs a primary key in order to add new columns and create metrics. Please set one."

    xor = (t1, t2) ->
      (t1 and not t2) or (not t1 and t2)

    $scope.noColumnsFound = false
    $scope.tableDefinitionLoading = false
    $scope.tableDefinitionBlocked = false

    # This needs to be an object because of the isolated scope dot rule
    $scope.selections =
      state: 'none'

    $scope.canAddColumns = false
    $scope.canRemoveColumns = false

    # Returns the currency code for a column. If its field_type is
    # value_currency, but it's currency_code property is null, then use the
    # default currency code for the client.
    getCurrencyCode = (localColumn) ->
      return undefined unless localColumn? and
        localColumn.field_type is 'value_currency'

      localColumn.currency_code ? app.getClientDefaultCurrency().code

    $scope.$watch 'table', (newTable, oldTable) ->
      $scope.tableDefinitionLoading = true
      $scope.tableDefinitionBlocked = true

      unless $scope.table?.localTableId?
        $scope.tableDefinitionLoading = false
      else
        $scope.showAllColumns = true
        if _canHideAlerts newTable, oldTable
          _hideAlerts()

        columnsResult = Columns.query
          tid: $scope.table.localTableId
          state: ["active"]
        , true

        columnsResult.then (localColumns) ->
          if $scope.table.isView
            $scope.combinedColumns = []
            $scope.combinedColumns = _(localColumns).map (localColumn) ->
              name: localColumn.name
              id: if localColumn? then localColumn.id else ""
              dataType: localColumn.old_data_type
              fieldType: localColumn.field_type
              derivativeTypeText: "From Your Database"
              isLocal: true
              isTracked: true
              isKey: false
              wasTracked: true
              state: if localColumn? then localColumn.state else ""
              is_in_serving_layer: if localColumn? then localColumn.is_in_serving_layer else false
              recheck: 'never'
              isView: if localColumn?.type is 'derivative' then false else true
              isDerivative: localColumn?.type is 'derivative'
              isEditable: _canEditColumn(localColumn)
              selected: false # This is for the checkboxes
              currencyCode: getCurrencyCode(localColumn)
              warehouse_name: if localColumn?.warehouse_name? then localColumn.warehouse_name else null
              derivType: if localColumn?.properties?.derivative_type and IS_SUPPORT_USER then localColumn.properties.derivative_type else ""
              recheckText: 
                text: _getRecheck(localColumn)
                tooltip: _getRecheckHoverText(localColumn)
          else
            $scope.combinedColumns = _($scope.table.remoteStructures).map (remoteStructure) ->
              localColumn = _(localColumns).find (localColumn) ->
                if remoteStructure.rsid?
                  return localColumn.remote_column_id == remoteStructure.rsid
                else
                  return localColumn.id == remoteStructure.metaData.id

              name = if localColumn? then localColumn.name else remoteStructure.name

              combinedColumn =
                name: name
                temp_name: name
                id: if localColumn? then localColumn.id else ""
                dataType: remoteStructure.metaData?.dataType ? remoteStructure.datatype
                fieldType: if localColumn? then localColumn.field_type else null
                derivativeTypeText: if remoteStructure.derivativeTypeText? then remoteStructure.derivativeTypeText else "From Your Database"
                isLocal: if remoteStructure.isLocal? then remoteStructure.isLocal else false
                isTracked: remoteStructure.isTracked or localColumn?.id?
                isKey: if $scope.table.localTableId and localColumn? then localColumn.is_primary_key else remoteStructure.isKey
                wasTracked: remoteStructure.isTracked or localColumn?.id?
                rsid: remoteStructure.rsid
                state: if localColumn? then localColumn.state else ""
                is_in_serving_layer: if localColumn? then localColumn.is_in_serving_layer else false
                isDerivative: localColumn?.type is 'derivative'
                isEditable: _canEditColumn(localColumn)
                selected: false # This is for the checkboxes
                currencyCode: getCurrencyCode(localColumn)
                recheck: if localColumn?.recheck? then localColumn.recheck else null
                warehouse_name: if localColumn?.warehouse_name? then localColumn.warehouse_name else null
                derivType: if localColumn?.properties?.derivative_type and IS_SUPPORT_USER then localColumn.properties.derivative_type else ""
                recheckText: 
                  text: _getRecheck(localColumn)
                  tooltip: _getRecheckHoverText(localColumn)
              return combinedColumn

          $scope.combinedColumns = _($scope.combinedColumns).sortBy (column) ->
            column.isDerivative

          $scope.selections.state = 'none'
          $scope.dropTable = false
          hasPKs = _hasPKs($scope.combinedColumns)
          unless hasPKs or $scope.table.isView
            $scope.alertMessage = "<strong>This table has no primary keys.</strong><br>#{pkAlert}"
          # if this is a tracked table and the user has untracked the last non-PK column but hasnt saved yet allow the Drop Local Table button
          $scope.isSyncedTable = $scope.table.trackedColor is -1 or $scope.table.trackedColor is 1

          $scope.noColumnsFound = _.isEmpty($scope.combinedColumns)
          $scope.updateIsSyncedTable()
          $scope.tableDefinitionLoading = false
          $scope.tableDefinitionBlocked = false
        , (error) ->
          notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "data-warehouse-notifications")
          $scope.tableDefinitionLoading = false
    , true

    _trackedFirstColumn = () ->
      # sets all PKs to be tracked in an untracked table to show the user what will happen
      for column in $scope.combinedColumns when column.isKey and not column.isTracked
        column.isTracked = true

    _untrackedFirstColumn = () ->
      # untracks all PKs in an untracked table if the user selects no non-PK columns for tracking
      for column in $scope.combinedColumns when column.isKey and not column.wasTracked
        column.isTracked = false

    _isTracked = (column) ->
      column.isTracked

    $scope.updateIsSyncedTable = () ->
      if $scope.combinedColumns?
        numberOfTrackedColumns = $scope.combinedColumns.filter(_isTracked).length

        if numberOfTrackedColumns is 1
          _trackedFirstColumn()
        if numberOfTrackedColumns is 0
          _untrackedFirstColumn()
        $scope.isSyncedTable = numberOfTrackedColumns >= 1 and $scope.table.trackedColor isnt 0

    setDirty = () ->
      $scope.state.pristine = false

    setPristine = () ->
      $scope.state.pristine = true
      _updateButtons()

    $scope.checkAll = () ->
      setDirty()
      for column in $scope.combinedColumns when not column.isView
        column.selected = true

    $scope.checkNone = () ->
      setDirty()
      for column in $scope.combinedColumns when not column.isKey
        column.selected = false

    # Tracks all selected columns and updates the backend
    $scope.addToWarehouse = () ->
      _trackSelected()
      if $scope.save()
        _unselectAll()

    # Drops any selected columns and updates the backend
    $scope.removeFromWarehouse = () ->
      if $scope.selections.state is "all"
        $scope.saveAndDropTable()
      else
        _untrackSelected()
        if $scope.save()
          _unselectAll()

    # Set isTracked for all selected columns
    _trackSelected = () ->
      $scope.alertMessage = 'Adding column(s) to warehouse...'
      for column in $scope.combinedColumns when column.selected? and column.selected
        column.isTracked = true

    # Set isTracked for all selected columns
    _untrackSelected = () ->
      for column in $scope.combinedColumns
        if column.selected? and column.selected and not column.isKey
          column.isTracked = false
        if column.selected? and column.selected and column.isKey
          column.selected = false

    $scope.toggleSelectAll = () ->
      # Check to see if there are any unselected columns
      for column in $scope.combinedColumns when column.selected is false and not column.isView
        _selectAll()
        _updateButtons()
        return

      # If not, unselect everything
      _unselectAll()
      _updateButtons()

    # Unselect all the checkboxes
    _unselectAll = () ->
      setPristine()
      for column in $scope.combinedColumns
        column.selected = false
      $scope.selections.state = 'none'

    # Select all the checkboxes
    _selectAll = () ->
      setDirty()
      for column in $scope.combinedColumns when not column.isView
        column.selected = true
      $scope.selections.state = 'all'

    _updateButtons = () ->
      # Parse the selection state and use it to set button states
      result = columnService.parseSelections($scope.combinedColumns)
      $scope.canAddColumns = result.columnsToAdd > 0
      $scope.canRemoveColumns = result.columnsToRemove > 0
      $scope.selections.state = columnService.getBulkSelectState(result.selected, result.unselected)
      if $scope.selections.state is "all"
        $scope.removeFromWarehouseTooltipText = "Drop Table"
      else
        $scope.removeFromWarehouseTooltipText = "Stop syncing selected column(s) from your data warehouse"

    # What to do when we change a column state
    $scope.handleSelectionChange = (column) ->
      columnService.updateSelections column, $scope.combinedColumns

      if column.selected
        setDirty()
        _updateButtons()
      else
        _updateButtons()
        return if _.some $scope.combinedColumns, (column) -> column.selected
        # If we found no selected columns, set pristine and select-all state
        setPristine()

    _revertColumnChanges = () ->
      for column in $scope.combinedColumns when not (column.justAdded and column.justRemoved)
        column.isTracked = Boolean(column.wasTracked)
      $scope.updateIsSyncedTable()

    $scope.reset = () ->
      setPristine()
      _hideAlerts()
      $scope.actionsBlocked = false
      _revertColumnChanges()

    $scope.displayDependencyResolver = false

    $scope.saveAndDropTable = () ->
      _hideAlerts()
      $scope.combinedColumns = _.map($scope.combinedColumns, (column) ->
        column.isTracked = false
        return column
      )
      $scope.dropTable = true
      $scope.save(false)

    # Returns a Boolean value indicating whether we actually hit the
    # remoteDBConnectionService.save endpoint, or whether saving was cancelled
    # by the user due to a confirmation dialog.
    $scope.save = (force = false) ->

      untrackedColumns = _.filter $scope.combinedColumns, (column) ->
        not (column.justAdded and column.justRemoved) and
          not column.isTracked and
          column.wasTracked

      trackedColumns = _.filter $scope.combinedColumns, (column) ->
        column.isTracked

      existingColumnsUntracked = untrackedColumns.length > 0

      setPristine()
      _hideAlerts()
      $scope.actionsBlocked = true

      if not force and existingColumnsUntracked
        $scope.displayDependencyResolver = true

      remoteDBConnectionService.save(
        $scope.table.localTableId
        $scope.combinedColumns
        app.getClientId()
        $scope.table.rowCount
        $scope.totalTrackedRows
        force
        $scope.dropTable
        not force and existingColumnsUntracked
        $scope.table.isView)
      .then(_successCallback).catch(_errorCallback)

      return true

    $scope.onConfirm = () ->
      $scope.displayDependencyResolver = false
      $scope.save(true)

    $scope.onCancel = () ->
      $scope.displayDependencyResolver = false
      $scope.reset()

    # This is complicated, so let the columnService handle this logic
    _getRecheck = (column) ->
      if $scope.localTable? and column?
        columnService.getDisplayedRecheckValue(column, $scope.localTable.replicator.type)

    _getRecheckHoverText = (column) ->
      if $scope.localTable? and column?
        columnService.getRecheckHoverText(column, $scope.localTable.replicator.type)

    $scope.getRecheckDocUrl = () ->
      dataWarehouse.RECHECK_DOC_URL

    _successCallback = ({data}) ->
      $scope.actionsBlocked = false
      if(data.success is true)
        logger.log('Data Warehouse Usage', 'Save', 1, 'edit')
        oneOrMoreColumnsAdded = false
        droppedTable = false
        if data.droppedTable?
          droppedTable = data.droppedTable
        # check that all columns that were supposed to be added were, mark any that werent as errored
        $scope.dependencies = data
        attemptedToRemoveColumnIds = _.pluck(data.attemptedToRemoveColumns, 'id')
        attemptedToRemoveDerivativeColumnsColumnIds = _.pluck(data.attemptedToRemoveDerivativeColumns, 'id')
        attemptedToAddColumnIds = _.pluck(data.attemptedToAddColumns, 'id')
        $scope.combinedColumns = _.map($scope.combinedColumns, (column) ->
          if droppedTable
            column.wasTracked = 0
            column.isTracked = false
            column.justAdded = false
            column.justRemoved = true
          else if xor(column.isTracked, column.wasTracked)
            column.justAdded = column.justRemoved = false
            if _.contains(data.addedColumns, column.rsid)
              column.wasTracked = 1
              column.isTracked = true
              column.justAdded = true
              oneOrMoreColumnsAdded = true
            else if _.contains(data.removedColumns, column.rsid) or _.contains(data.removedDerivativeColumns, column.id)
              column.wasTracked = 0
              column.isTracked = false
              column.justRemoved = true
            else if _.contains(attemptedToRemoveColumnIds, column.rsid) or _.contains(attemptedToRemoveDerivativeColumnsColumnIds, column.id)

              column.hasDependencies = true
            else if not _.contains(attemptedToAddColumnIds, column.rsid)
              column.isError = true
          column
        )
        hasPKs = _hasPKs($scope.combinedColumns)
        if data.removedColumns.length > 0 or oneOrMoreColumnsAdded
          $rootScope.$broadcast('tablePreviewRefresh')

        if data.removedDerivativeColumns? and data.removedDerivativeColumns.length > 0
          $rootScope.$broadcast('derivativeColumnsDropped')

        # update table and total row information and show success messages
        if $scope.table.trackedColor != 0 and oneOrMoreColumnsAdded and not hasPKs and not $scope.table.isView
          $scope.alertMessage = "<strong>Configuration incomplete.</strong><br>#{pkAlert}"
        else if $scope.table.trackedColor != 0 and oneOrMoreColumnsAdded
          $scope.alertMessage = '<strong>Successfully added new column(s).</strong><br>Your data will be synced with Adobe Commerce Intelligence during your next update.'
        else if (data.removedColumns.length > 0 or data.removedDerivativeColumns?.length > 0) and not droppedTable and not hasPKs and not $scope.table.isView
          $scope.alertMessage = "<strong>Configuration incomplete.</strong><br>#{pkAlert}"
        else if (data.removedColumns.length > 0 or data.removedDerivativeColumns?.length > 0) and not droppedTable
          $scope.alertMessage = 'Successfully dropped column(s).'
        else if $scope.table.trackedColor == 0 and oneOrMoreColumnsAdded
          $scope.table.trackedColor = -1
          $rootScope.$broadcast('addTable', $scope.table.rsConnectionId, $scope.table.database, $scope.table.schema, $scope.table.name, data.localTableId)
          $rootScope.$broadcast 'initiateNewTable', data.localTableId
          $scope.totalTrackedRows += $scope.table.rowCount
          $scope.table.localTableId = data.localTableId
          $scope.table.id = data.localTableId
          $rootScope.$broadcast('dataWarehouse.columnSyncChanged', $scope.table)
          if hasPKs
            $scope.alertMessage = "<strong>Successfully added table #{$scope.table.name}.</strong><br>Your data will be synced with Adobe Commerce Intelligence during your next update."
          else
            $scope.alertMessage = "<strong>Table #{$scope.table.name} configuration incomplete.</strong><br>#{pkAlert}"
        else if ($scope.table.trackedColor is -1 or $scope.table.trackedColor is 1) and droppedTable
          $scope.dropTable = false
          $scope.table.trackedColor = 0
          $rootScope.$broadcast('droppedTable', $scope.table.rsConnectionId, $scope.table.database, $scope.table.schema, $scope.table.name)
          $scope.totalTrackedRows -= $scope.table.rowCount
          $scope.isSyncedTable = false
          $scope.table.localTableId = 0
          $rootScope.$broadcast('dataWarehouse.columnSyncChanged', $scope.table)
          $scope.alertMessage = 'Successfully dropped table "'+$scope.table.name+'"'
        # re-initialize the original scope so the changes are persisted if reset again
        $scope.actionsBlocked = false
      else
        $scope.alertMessage = data.message
        $scope.actionsBlocked = false
      $scope.updateIsSyncedTable()
      StructureCache.getStructure(true)

    _hasPKs = (combinedColumns) ->
      pkCheck = false
      combinedColumns.map (column) ->
        if column.isKey
          pkCheck = true
      return pkCheck

    _errorCallback = (error) ->
      $scope.actionsBlocked = false
      notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "data-warehouse-notifications")
      $scope.tableDefinitionBlocked = true

    $scope.columnStyle = columnService.getStyle
    $scope.getHelp = columnService.getHelp

    $scope.forceUpdate = () ->
      #JobType::FULL_UPDATE
      fullUpdateJob = 2
      jobService(fullUpdateJob).queue(
        {isForced : 1},
        () ->
          notification.success("Update successfully queued", "Update successfully queued.", "global")
        ,
        () ->
          notification.error("Unable to queue update", "Unable to queue update at this time, please try again later.", "global")
      )
      $scope.alertMessage = ''

    _canEditColumn = (column) ->
      not _isSelfJoin(column) \
        and not _isMultiHopJoin(column) \
        and rjdl.getConverterOrNull(column)? \
        and not _hasMoreThanOneKey(column) \
        and _canEditBeta(column)

    _isSelfJoin = (column) ->
      if column? and column?.properties?.joins
        if column.properties.joins[0].local_column_ids?
          localColumnId = column.properties.joins[0].local_column_ids[0]
        if column.properties.joins[0].foreign_column_ids?
          foreignColumnId = column.properties.joins[0].foreign_column_ids[0]
        return localColumnId? and foreignColumnId? and localColumnId is foreignColumnId
      else
        return false

    _isMultiHopJoin = (column) ->
      if column?.properties?.joins
        return column.properties.joins.length > 1
      else
        return false

    _hasMoreThanOneKey = (column) ->
      if column? and column?.properties?.joins
        return column.properties.joins[0].local_column_ids.length > 1 and column.properties.joins[0].foreign_column_ids.length > 1
      else
        return false

    _canEditBeta = (column) ->
      flags =
        calculation: "RJQL_SERVICE_CLIENT"
        date_diff: "RJQL_SERVICE_CLIENT"
        sequence: "RJQL_SERVICE_CLIENT"
        sequential_comparison: "RJQL_SERVICE_CLIENT"

      type = column?.properties?.derivative_type
      # allow editing of non beta columns
      unless flags[type]?
        return true

      column? \
        and app.hasFeatureFlag('RJQL_SERVICE_CLIENT') \
        and (app.hasFeatureFlag(flags[type]) or IS_SUPPORT_USER)

    _canHideAlerts = (n, o) ->
        return n.name isnt o.name or
          n.schema isnt o.schema or
          n.database isnt o.database or
          n.rsConnectionId isnt o.rsConnectionId

    _hideAlerts = () ->
      notification.clear("global")
      $scope.alertMessage = ''

    $scope.editColumn = (id) ->
      $timeout ->
        $anchorScroll('columnEditor')
      $rootScope.$broadcast('editColumn', id)

    $scope.setRecheckFrequency = (freq) ->
      recheckMessage = ''
      if columnService.hasInvalidRecheckSelections($scope.combinedColumns)
        recheckMessage = "Some of the columns you selected don't need rechecks, so we skipped them for you. You're all set!"

      columns = columnService.getSelectedNativeColumns($scope.combinedColumns)
      columnService.setRecheckFrequencies(columns, freq).then( (success) ->
        notification.success("Success",
          "Success:  Recheck frequencies have been set. #{recheckMessage}",
          "global")
        logger.log('Set Recheck Frequency', 'Save', columns.length, freq)
        setPristine()
      , (error) ->
        notification.error("Error",
          "Error: There was a problem setting the recheck frequencies. Please contact support.",
          "global"
        )
      )

    $scope.setPk = (value) ->
      columns = columnService.getSelectedNativeColumns($scope.combinedColumns)
      valueAsInt = if value is true then 1 else 0
      columnService.setPks(columns, valueAsInt).then( (success) ->
        notification.success("Success",
          "Success:  Primary key status has been set.",
          "global")
        logger.log('Set Pk', 'Save', columns.length, value)
        setPristine()
        lockTableById($scope.table.id)
      , (error) ->
        notification.error("Error",
          "Error: There was a problem setting primary keys. Please contact support.",
          "global"
        )
      )

    $scope.setFieldType = (fieldType) ->
      columns = (col for col in $scope.combinedColumns when col.selected? and col.selected)
      columnService.setFieldTypes(columns, fieldType.id).then( (success) ->
        notification.success("Success",
          "Success:  Field Type has been set.",
          "global")
        logger.log('Set Field Type', 'Save', columns.length, fieldType.id)
        setPristine()
      , (error) ->
        notification.error("Error",
          "Error: There was a problem setting field types. Please contact support.",
          "global"
        )
      )

    $scope.setColumnName = (column) ->
      tempName = column.temp_name
      if not column.temp_name? or
        column.temp_name.length is 0 or
        column.temp_name.length > 255
          column.temp_name = column.name
      else
        columnService.setName(column, "temp_name", $scope.table.id).then(
          (success) ->
            notification.success("", "Success: Column name has been set to <strong>#{tempName}</strong>.", "data-warehouse-notifications", null, 10)
            notification.warning("", "Warning: Warning: Any SQL reports #{ADDITION_TO_NOTIFICATION}that used the old column name must now be edited to refer to this new column name.", "data-warehouse-notifications", null, 20)
          , (error) ->
            if error is "name_already_exists"
              notification.error("", "Error: Name <strong>#{tempName}</strong> has already been taken. Name must be unique in table (case insensitive).", "data-warehouse-notifications", null, 10)
            else
              notification.error("", "Error: There was a problem setting column name. Please try again or contact support.", "data-warehouse-notifications", null, 10)
        )

    $scope.canSetColumnName = (column) ->
      return not $scope.table.isView and
        columnService.canSetName(column)

    lockTableById = (tableId) ->
      # Grab the table
      Tables.get(tableId).then( (table) ->
        unless table.is_primarykey_locked
          lockTable(table)
      , handleLockError)

    lockTable = (table) ->
      # We need to delete this until the schema service can handle it
      delete table.remote_table
      table.is_primarykey_locked = true

      Tables.save(table).catch handleLockError

    handleLockError = (error) ->
      notification.error("Error",
        "We had a problem locking the primary key status of this table. Running a structure sync may revert it back to the previous state. Please contact support.",
        "global"
      )

    $scope.canSetRechecks = () ->
      unless $scope.localTable?
        return false
      columnService.allowRechecks($scope.localTable.replicator.type, $scope.combinedColumns)

    $scope.canSetPk = () ->
      unless $scope.localTable?
        return false
      if $scope.localTable.replicator.type == 'userpush'
        return false
      if $scope.localTable.isView
        return false
      return true

    $scope.canSetFieldType = () ->
      unless $scope.localTable?
        return false
      return true

    $scope.getRecheckButtonText = () ->
      unless $scope.localTable?
        return ''
      columns = $scope.combinedColumns
      repMethod = $scope.localTable.replicator.type
      columnService.getRecheckButtonText(repMethod, columns)

    $scope.getPkButtonText = () ->
      return "Change the primary key status of selected columns"

    $scope.getFieldTypeButtonText = () ->
      return "Change the field type of selected columns"

    # If someone outside the directive tells us to drop a table, do it
    $scope.$on 'dropTable', () ->
      $scope.saveAndDropTable()
]

angular.module('rjmNg.directives').directive 'columnList', [
  () ->
    restrict: 'E'
    templateUrl: "settings/directive.columnList.html"
    scope: {
      table: '='
      localTable: '='
      totalTrackedRows: '=trackedRows'
      state: '='
    }
    controller: 'columnListCtrl'
]
